import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import SetupChecklistSteps from "./SetupChecklistSteps";
const ReadinessWarningBanner = () => {
  const { t } = useTranslation("enterprise_data_tiering");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning", title: t("warm_tier_readiness.title") }, /* @__PURE__ */ React.createElement("p", null, t("readiness_banner.text")), /* @__PURE__ */ React.createElement(SetupChecklistSteps, null));
};
export default ReadinessWarningBanner;
